import { ActionTypes } from "../constants/action-types";

const initialState = {
  linkedinUrlData: [],
};

const FetchLinkedinUrl = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_LINKEDIN_URL:
      return {
        ...state,
        linkedinUrlData: action.payload,
      };

    default:
      return state;
  }
};

export default FetchLinkedinUrl;